module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "transfer-title"
  }, [_vm._v("应收账款转让通知书列表")]), _vm._v(" "), _c('div', {
    staticClass: "transfer-list"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "transfer-list__search",
    attrs: {
      "inline": true,
      "model": _vm.search,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "通知书编号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.search.adviceCode),
      callback: function($$v) {
        _vm.$set(_vm.search, "adviceCode", $$v)
      },
      expression: "search.adviceCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同编号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.search.contractNo),
      callback: function($$v) {
        _vm.$set(_vm.search, "contractNo", $$v)
      },
      expression: "search.contractNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "项目编号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.search.applyCode),
      callback: function($$v) {
        _vm.$set(_vm.search, "applyCode", $$v)
      },
      expression: "search.applyCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "项目名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.search.applyTitle),
      callback: function($$v) {
        _vm.$set(_vm.search, "applyTitle", $$v)
      },
      expression: "search.applyTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.search.productName),
      callback: function($$v) {
        _vm.$set(_vm.search, "productName", $$v)
      },
      expression: "search.productName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "核心企业"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.search.buyerName),
      callback: function($$v) {
        _vm.$set(_vm.search, "buyerName", $$v)
      },
      expression: "search.buyerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchList
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.adviceList,
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "65",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "adviceCode",
      "show-overflow-tooltip": "",
      "label": "通知书编号",
      "width": "110",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "applyCode",
      "show-overflow-tooltip": "",
      "label": "项目编号",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "applyTitle",
      "show-overflow-tooltip": "",
      "label": "项目名称",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "产品名称",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buyerName",
      "show-overflow-tooltip": "",
      "label": "买方",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "adviceState",
      "show-overflow-tooltip": "",
      "label": "确认状态",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createtime",
      "show-overflow-tooltip": "",
      "label": "日期",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "btn operation",
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.goToDetail(scope.row.adviceId)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.adviceList.length > 0) ? _c('el-pagination', {
    staticClass: "transfer-list__pagination",
    attrs: {
      "page-size": _vm.pageSize,
      "total": _vm.totalCount,
      "current-page": _vm.currentPage,
      "layout": "prev, pager, next"
    },
    on: {
      "current-change": _vm.changePage
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0387990"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/TransferAdviceList.vue
// module id = 1094
// module chunks = 1